import { useEffect, useState } from "react";
import AdminPanelHead from "./UI elements/AdminPanelHead";
import Navigator from "./UI elements/Navigator";
import Filters from "./UI elements/Filters";
import UserManagement from "./Components/UserManagement";
import Settings from "./Components/Settings";
import Categories from "./Components/Categories";
import AISettings from "./Components/AISettings";
import UnsavedhangesModal from "./UI elements/UnsavedChangesModal";

const AdminPanel = (props) => {
  const [SelectedNavTab, setSelectedNavTab] = useState("FIRST");
  const [EditUserIsActive, setEditUserIsActive] = useState(false);
  const [SelectedFilters, setSelectedFilters] = useState({
    profiles: [],
    statuses: [],
    keyword: "",
  });
  const [HasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [LastClickedId, setLastClickedId] = useState();
  const [ShouldClick, setShouldClick] = useState(false);

  useEffect(() => {
    if (!HasUnsavedChanges && ShouldClick) {
      document.getElementById(LastClickedId).click();
      setShouldClick(false); // Reset the shouldClick state
    }
  }, [HasUnsavedChanges, ShouldClick, LastClickedId]);

  const toggleUpdateUserManagementData = (Profiles, Statuses) => {
    if (!Profiles || !Statuses) {
      setSelectedFilters({
        profiles: [...SelectedFilters.profiles],
        statuses: [...SelectedFilters.statuses],
        keyword: document.getElementById("search-input").value,
      });
    } else {
      setSelectedFilters({
        profiles: Profiles,
        statuses: Statuses,
        keyword: document.getElementById("search-input").value,
      });
    }
  };

  const handleSwitchTab = (TabNum, TabId) => {
    setLastClickedId(TabId);

    if (!HasUnsavedChanges) {
      setSelectedNavTab(TabNum);
    } else {
      setModalIsOpen(true);
    }
  };

  const toggleDiscardAndLeave = () => {
    setModalIsOpen(false);
    setHasUnsavedChanges(false);
    setShouldClick(true);
  };

  return (
    <>
      <AdminPanelHead />
      <div className="profile-wrapper admin-panel-wrapper">
        {ModalIsOpen ? (
          <UnsavedhangesModal
            Save={() => document.getElementById("save-btn").click()}
            DisacardAndLeave={() => toggleDiscardAndLeave()}
            Close={() => setModalIsOpen(false)}
          />
        ) : null}
        <div className="left-side">
          <Navigator
            SwitchTab={(TabNum, TabId) => handleSwitchTab(TabNum, TabId)}
            SaveClickedId={(Id) => setLastClickedId(Id)}
            SetEditUserIsActive={(Bool) => setEditUserIsActive(Bool)}
            SelectedNavTab={SelectedNavTab}
          />
          <Filters
            SelectedNavTab={SelectedNavTab}
            EditUserIsActive={EditUserIsActive}
            ToggleSearch={(Profiles, Statuses) =>
              toggleUpdateUserManagementData(Profiles, Statuses)
            }
            SaveProfileFilters={() => null}
            SaveStatusFilters={() => null}
          />
        </div>
        {SelectedNavTab === "FIRST" ? (
          <UserManagement
            SetEditUserIsActive={(Bool) => setEditUserIsActive(Bool)}
            SelectedFilters={SelectedFilters}
          />
        ) : (
          <>
            {SelectedNavTab === "SECOND" ? (
              <Settings />
            ) : (
              <>
                {SelectedNavTab === "THIRD" ? (
                  <AISettings
                    SetModalIsOpen={(Bool) => setModalIsOpen(Bool)}
                    SetLastClickedId={(Id) => setLastClickedId(Id)}
                    LastClickedId={LastClickedId}
                    HasUnsavedChanges={HasUnsavedChanges}
                    SetHasUnsavedChanges={(Bool) => setHasUnsavedChanges(Bool)}
                  />
                ) : (
                  <Categories />
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanel;
